import * as React from 'react';
import * as main from "../../main.module.scss";
import * as who from "./style.module.scss";
export const Who = () => {
  return (
    <section className={`${who.who} ${main.hugs}`}>
      <div className="container">
        <h2 className={main.title}>
          Сегодня <span className={who.colorViolet}>вы решаете</span> кем ваш ребёнок будет завтра
        </h2>
        <ul className={who.listMain}>
          <li className={who.strategist}>
            <h3>Родитель <span className={who.colorViolet}>стратег</span></h3>
            <ul>
              <li>Дает удочку, а&nbsp;не&nbsp;рыбу</li>
              <li>Воспитывает успешную личность</li>
              <li>Зарождает интерес к&nbsp;учебе</li>
              <li>Помогает найти решение</li>
              <li>Прививает навык обучения</li>
            </ul>
          </li>
          <li className={who.tactic}>
            <h3>Родитель <span className={who.colorOrange}>тактик</span></h3>
            <ul>
              <li>Гоняется за&nbsp;оценками</li>
              <li>Борется с&nbsp;сопротивлением ребёнка</li>
              <li>Постоянно «причиняет ребёнку добро» и сомневается в&nbsp;его будущем</li>
            </ul>
          </li>
        </ul>
      </div>
    </section>
  );
};
